import { useState } from "react";
import { MessageCircle, Phone, X } from "lucide-react";
import { WHATSAPP_NUMBERS, PHONE_NUMBERS } from "../lib/api";
import { track } from "../lib/track";

export function ContactWidget({ bottom = "bottom-6", message }) {
  const [open, setOpen] = useState(false);
  const msg = encodeURIComponent(message || "Ciao Fantini Next Mobility! Vorrei alcune informazioni.");
  return (
    <div className={`fixed ${bottom} right-4 md:right-6 z-50 flex flex-col items-end gap-3`}>
      {open && (
        <>
          {WHATSAPP_NUMBERS.map((w, i) => (
            <a
              key={`w${i}`}
              href={`https://wa.me/${w.number}?text=${msg}`}
              target="_blank"
              rel="noreferrer"
              onClick={() => track("click_whatsapp", { label: w.label })}
              data-testid={`whatsapp-contact-${i}`}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white border border-border shadow-floating text-sm hover:-translate-y-0.5 transition-transform"
            >
              <MessageCircle size={16} strokeWidth={1.5} className="text-forest" /> WhatsApp {w.label}
            </a>
          ))}
          {PHONE_NUMBERS.map((p, i) => (
            <a
              key={`p${i}`}
              href={`tel:${p.tel}`}
              onClick={() => track("click_phone", { label: p.sub })}
              data-testid={`phone-contact-${i}`}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white border border-border shadow-floating text-sm hover:-translate-y-0.5 transition-transform"
            >
              <Phone size={16} strokeWidth={1.5} className="text-ink" />
              <span>{p.label} <span className="text-ink-soft">· {p.sub}</span></span>
            </a>
          ))}
        </>
      )}
      <button
        data-testid="contact-fab"
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-2 px-6 py-4 rounded-full bg-ink text-white text-sm shadow-floating hover:opacity-90 transition-opacity"
      >
        {open ? <X size={16} strokeWidth={1.5} /> : <MessageCircle size={16} strokeWidth={1.5} className="text-[#68b39d]" />}
        {open ? "Chiudi" : "Contattaci"}
      </button>
    </div>
  );
}
